<template>
    <span class="icon-counter" v-show="value>0">{{ value }}</span>
</template>

<script>
    export default {
        name: "SiteHeaderNotificationsCounter",
        props: {
            value: Number,
        },
    };
</script>

<style scoped lang="scss">
    .icon-counter {
        border-radius: 50%;
        width: 1.75rem;
        height: 1.75rem;
        position: absolute;
        background-color: var(--color-notification-badge);
        color: var(--color-on-fill);
        text-align: center;
        line-height: 1.75rem;
        // grows to the right, so it covers no more of the icon than at Default
        right: calc(18px - 1.75rem);
        top: 0;

        // phones show the header icons alone, at a fixed size and with no room beside them
        @media (max-width: 500px) {
            width: 28px;
            height: 28px;
            // stylelint-disable-next-line declaration-property-unit-disallowed-list -- sized with the header icons
            font-size: 14px;
            // stylelint-disable-next-line declaration-property-unit-disallowed-list -- sized with the header icons
            line-height: 28px;
            right: -10px;
        }
    }
</style>